import { pdfjs } from "react-pdf";

/**
 * pdf.js resolves its worker from a single module-level global
 * (`pdfjs.GlobalWorkerOptions`), shared by every `react-pdf` consumer in the
 * app. When more than one view assigns it at import time, the module the
 * bundler happens to evaluate last silently wins for all of them — so the
 * assignment lives here, once, and views call `configurePdfWorker` instead.
 *
 * The version is read from the bundled pdf.js rather than pinned, because the
 * worker and the API that loads it must be the same build: a mismatch makes
 * pdf.js refuse to render rather than fall back.
 */
export const PDF_WORKER_SRC = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const configurePdfWorker = (): void => {
  pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;
};
